import React, { useState } from 'react';
import { Input, Button, Space } from 'antd';
import { SendOutlined, PictureOutlined } from '@ant-design/icons';
import { createStyles } from 'antd-style';

const { TextArea } = Input;

const useStyles = createStyles(({ token }) => ({
    inputContainer: {
        padding: '12px 16px 16px',
        backgroundColor: token.colorBgContainer,
    },
    statusMessage: {
        marginTop: '8px',
        fontSize: '12px',
    },
    errorMessage: {
        color: '#ff4d4f',
    },
    infoMessage: {
        color: '#999',
    },
}));

interface MessageInputProps {
    connected: boolean;
    loading: boolean;
    qrListEmpty: boolean;
    qrLoading: boolean;
    onSendMessage: (message: string, messageType?: 'text' | 'image') => void;
    onImageSelect?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MessageInput: React.FC<MessageInputProps> = ({
    connected,
    loading,
    qrListEmpty,
    qrLoading,
    onSendMessage,
    onImageSelect,
}) => {
    const { styles } = useStyles();
    const [inputValue, setInputValue] = useState('');

    // 发送消息
    const handleSendMessage = () => {
        if (!inputValue.trim() || !connected) {
            return;
        }
        onSendMessage(inputValue.trim());
        setInputValue('');
    };

    // 处理回车发送
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <div className={styles.inputContainer}>
            <Space.Compact style={{ width: '100%' }}>
                <TextArea
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="输入消息..."
                    autoSize={{ minRows: 1, maxRows: 3 }}
                    disabled={!connected}
                    maxLength={500}
                />
                {onImageSelect && (
                    <Button
                        icon={<PictureOutlined />}
                        onClick={() => {
                            const input = document.createElement('input');
                            input.type = 'file';
                            input.accept = 'image/*';
                            input.onchange = (e) => {
                                const target = e.target as HTMLInputElement;
                                const event = {
                                    target: target
                                } as React.ChangeEvent<HTMLInputElement>;
                                onImageSelect(event);
                            };
                            input.click();
                        }}
                        disabled={!connected}
                        style={{ height: '32px' }}
                    >
                        图片
                    </Button>
                )}
                <Button
                    type="primary"
                    icon={<SendOutlined />}
                    onClick={handleSendMessage}
                    disabled={!connected || !inputValue.trim() || loading}
                    loading={loading}
                    style={{ height: '32px' }}
                >
                    发送
                </Button>
            </Space.Compact>
            {!connected && (
                <div className={`${styles.statusMessage} ${styles.errorMessage}`}>
                    连接已断开，请检查网络连接
                </div>
            )}
            {qrListEmpty && !qrLoading && (
                <div className={`${styles.statusMessage} ${styles.infoMessage}`}>
                    暂无可用的二维码
                </div>
            )}
        </div>
    );
}; 